// components/LanguageSwitcher.js
import React, { useState } from 'react';
import { Globe, ChevronDown } from 'lucide-react';
import { availableLanguages } from '../languages';

const LanguageSwitcher = ({ currentLanguage, onLanguageChange, theme }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const currentLang = availableLanguages.find(lang => lang.code === currentLanguage);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center space-x-2 ${theme.bg.tertiary} ${theme.bg.hover} ${theme.text.secondary} px-3 py-2 rounded-lg text-sm transition-all duration-200 ${theme.border.secondary} border ${theme.border.hover} hover:${theme.text.primary}`}
        aria-label="Change language"
      >
        <Globe className="w-4 h-4" />
        <span>{currentLang?.flag}</span>
        <span>{currentLang?.name}</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className={`absolute top-full mt-1 right-0 ${theme.bg.secondary} ${theme.border.primary} border rounded-lg shadow-lg z-50 min-w-[120px]`}>
          {availableLanguages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => {
                onLanguageChange(lang.code);
                setIsOpen(false);
              }}
              className={`w-full flex items-center space-x-2 px-3 py-2 text-left ${theme.text.secondary} hover:${theme.bg.hover} hover:${theme.text.primary} transition-colors first:rounded-t-lg last:rounded-b-lg ${
                currentLanguage === lang.code ? `${theme.bg.accent} ${theme.text.onAccent}` : ''
              }`}
            >
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </button>
          ))}
        </div>
      )}

      {/* Click outside to close */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default LanguageSwitcher;